/**
 * @author       samuel@zumper.com (Samuel Shih)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  trackPerformanceMetricsEvent.js
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { event } from '@zcode-ui/web-zumper-integrations'
import { getCurrentLocation } from '../../../inspectors/index'

export const trackPerformanceMetricsEvent =
  ({ additionalProps, name }) =>
  (dispatch, getState) => {
    const state = getState()

    const user = getUser(state)
    const location = getCurrentLocation(state)

    dispatch(event({ name, props: additionalProps, user, location }))
  }
